<template>
	<div class="media-item">
		<a class="thumbnail" :href="item?.info?.url" target="_blank">
			<b-img-lazy :blank="!item?.info?.thumbnail" blank-color="#ccc" :src="item?.info?.thumbnail" :alt="item?.info?.title||''" v-if="item?.info?.thumbnail" />
			<div class="placeholder" v-else></div>
			<div class="embed-responsive-item bg-secondary"></div>
			<span class="duration" v-if="item?.info?.duration">{{item?.info.duration|secondsToTime}}</span>
		</a>
		<div class="details">
			<h6 class="title" :title="item?.info.title"><a :href="item?.info?.url" target="_blank">{{item?.info?.title||item?.info?.url}}</a></h6>
			<p class="author">{{item?.info.author}}</p>
			<p class="metrics"><span v-if="item?.info?.views">{{ item?.info.views|money }} views</span><span v-if="item?.posted_at && item?.info.views"> • <time-ago :date="item?.info.posted_at" /></span> <b-badge>{{item?.status}}</b-badge></p>
			<p class="status">
				<span :class="[ 'giftValue', `gift-${getGiftThreshold(item).value}` ]" v-if="item?.value > 0">{{item?.valueString}}</span><span v-if="item?.added_at"> added <time-ago :date="item?.added_at" /> </span><span v-if="item?.updated_at && item.added_at != item.updated_at">, updated <time-ago :date="item?.updated_at" /> </span>
				<span v-if="item.timeLimit > 0"> playing {{item.timeLimit|secondsToTime}}</span>
				<span v-if="item.info?.start_time > 0"> starting at {{item.info.start_time|secondsToTime}}</span>
			</p>
		</div>
		<div v-if="$slots.dropdown?.length > 0">
			<b-dropdown
				variant="link"
				no-caret
				right
				toggle-class="p-0"
				menu-class="shadow-sm"
			>
				<template #button-content>
					<b-icon icon="three-dots-vertical" style="cursor: pointer;"></b-icon>
				</template>

				<slot name="dropdown"></slot>
			</b-dropdown>
		</div>
	</div>
</template>

<script>
import TimeAgo from './TimeAgo.vue';
import util from '../util';
import giftThresholds from '../GiftThresholds';

const styleId = 'media-item-thresholds-style';
let style = document.getElementById(styleId);
if(!style) {
	style = document.createElement('style');
	style.type = 'text/css';
	style.id = styleId;
	document.head.appendChild(style);
}

style.innerHTML = giftThresholds.map(t => `
	.media-item > .details > .status > .giftValue.gift-${t.value} {
		color: ${util.getContrastingTextColor(t.color)};
		background-color: ${t.color};
	}
`).join('');

export default {
	components: {
		TimeAgo,
	},
	props: {
		item: Object,
	},
	filters: {
		secondsToTime: util.secondsToTime,
		formatSQLDate: function(d) {
			let date = util.sqlStringToDate(d);
			return date ? date.toLocaleString() : '-';
		},
		money: util.moneyString
	},
	methods: {
		getGiftThreshold(item) { return util.getGiftThreshold(item?.value||0, giftThresholds); },
	},
}
</script>

<style lang="scss">
@import '../plugins/variable.scss';
@import 'bootstrap/scss/functions';
@import 'bootstrap/scss/variables';
@import 'bootstrap/scss/mixins';

.media-item {
	display: flex;

	> .thumbnail {
		position: relative;
		margin-right: 1rem;
		flex-shrink: 0;
		overflow: hidden;
		width: 160px;
		height: 90px;

		> img {
			width: 100%;
			height: 100%;
			object-fit: cover;
		}

		> .duration {
			position: absolute;
			color: $vaporwave-white;
			background-color: $vaporwave-bg;
			padding: .1em .3em;
			border-radius: 3px;
			bottom: .2em;
			right: .2em;
			font-size: .8em;
			font-weight: bold;
			opacity: 0.85;
		}

		> .placeholder {
			background: $vaporwave-bg;
			width: 160px;
			height: 90px;
		}
	}
	> .details {
		flex-grow: 1;

		> .title {
			margin-bottom: .3rem;
			font-weight: bold;
			font-size: 0.9rem;
			display: -webkit-box;
			-webkit-line-clamp: 2;
			-webkit-box-orient: vertical;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		> .author {
			margin-bottom: 0;
			color: $text-muted;
			font-size: 0.8rem;
		}

		> .metrics {
			margin-bottom: 0;
			color: $text-muted;
			font-size: 0.75rem;
		}

		> .status {
			margin-bottom: 0;
			color: $text-muted;
			font-size: 0.75rem;

			> .giftValue {
				background: $gold;
				color: $dark;
				padding: .3em .5em;
				font-weight: bold;
				border-radius: .4em;
			}
		}
	}
}

@container (max-width: #{breakpoint-max(xs)}) {
	.media-item {
		> .thumbnail {
			width: 90px;
			height: 90px;
		}
	}
}
</style>
